<template>
  <FormLayout class="discussion-form">
    <v-btn text class="px-0" color="primary" @click="back">
      <v-icon>{{ mdiChevronLeft }}</v-icon>
      Back to discussions
    </v-btn>
    <DiscussionErrors :errors="errors" />

    <v-div mt-4>
      <h2 class="title pb-2">Create discussion</h2>
      <v-div>
        <p class="caption primary--text">
          All fields marked with a * are mandatory.
        </p>
      </v-div>

      <DataItemRadio
        :errors="errors"
        :item="item"
        :update-action="updateAction"
        :options="typeOptions"
        field-name="type"
        title="Type*"
        information="Your post can be classified as an announcement (e.g. calls for papers, academic conferences), a question (e.g. broad research questions, research practice questions) or a comment (e.g. a summary or review of a paper you’ve read recently)."
        information-label="discussion type tooltip"
        :is-required="true"
      />
      <DataItemText
        :errors="errors"
        :item="item"
        :update-action="updateAction"
        placeholder="Enter the title of your discussion here"
        field-name="title"
        autocomplete="given-name"
        title="Title*"
        :is-required="true"
      />

      <DataItemTextArea
        class="mb-3"
        :errors="errors"
        :item="item"
        :update-action="updateAction"
        field-name="description"
        title="Description*"
        :is-required="true"
      >
        <CommunityDiscussionModerationNotification
          notification-title="Discussions"
          class="mt-n3"
        />
      </DataItemTextArea>
      <DataLayout>
        <v-btn
          class="primary inverted--text my-4 mr-4"
          @click="createDiscussion"
          >Create</v-btn
        >
      </DataLayout>
    </v-div>
  </FormLayout>
</template>

<script>
import { mdiChevronLeft } from "@mdi/js";
import {
  gtmEventCategories,
  gtmEventActions,
} from "~/components/utilities/gtmEventEnums";

import FormLayout from "~/components/forms/components/layout/FormLayout.vue";

import DataItemTextArea from "~/components/forms/components/DataItemTextArea";
import DataItemText from "~/components/forms/components/DataItemText";
import DataItemRadio from "~/components/forms/components/DataItemRadio";
import DiscussionErrors from "~/components/forms/DiscussionErrors.vue";
import DataLayout from "~/components/forms/components/layout/DataLayout";
import CommunityDiscussionModerationNotification from "~/components/communities/discussion/CommunityDiscussionModerationNotification.vue";

import saveForDiscussion from "~/actions/tasks/saveForDiscussion";

export default {
  name: "DiscussionForm",
  components: {
    FormLayout,
    DataItemTextArea,
    DataItemText,
    DataItemRadio,
    DiscussionErrors,
    CommunityDiscussionModerationNotification,
    DataLayout,
  },
  props: {
    item: { type: Object, required: true },
    errors: {
      type: Array,
      default: () => [],
    },
    updateAction: { type: String, default: "" },
    community: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      showErrors: false,
      typeOptions: ["Announcement", "Comment", "Question"],
      // Icons
      mdiChevronLeft,
    };
  },
  methods: {
    async createDiscussion() {
      const data = await saveForDiscussion.call(this);

      if (data) {
        this.$store.dispatch("clearProposedDiscussion");
        this.$root.$emit("show-accessible-snackbar", {
          confirmationMessage: "Discussion created successfully!",
        });
        this.$router.replace({
          query: { ...this.$route.query, view: "discussion-overview" },
        });
        this.$store.dispatch("loadCommunityDiscussionListing", {
          params: { communityId: this.community.id, skip: 0, limit: 5 },
        });
        this.sendGtmEvent();
      }
    },
    back() {
      this.$emit("changeTab", "discussion-overview");
    },
    sendGtmEvent() {
      this.$gtm.push({
        event: gtmEventActions.CLICK_DISCUSSION_CREATE,
        category: gtmEventCategories.COMMUNITY_DISCUSSIONS,
        label: this.community.name,
      });
    },
  },
};
</script>
